<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stock/stockin-list">{{$t('stock_in_list')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('vendor')}}</label>
                                <div>
                                    <VendorSelector @select="vendorSelected" :value="stockin.VendorName" place="Choose a vendor"></VendorSelector>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.stockin.BranchId.$error }">
                                <label class="label-control blue">{{$t('branch_name')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="stockin.BranchId">
                                        <option value="">Not Set</option>
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.stockin.EmployeeId.$error }">
                                <label class="label-control blue">{{$t('receiver')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="stockin.EmployeeId">
                                        <option value="">Not Set</option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.KhmerName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="stockdate" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="blue">{{$t('item_name')}}</th>
                                        <th class="blue">{{$t('description')}}</th>
                                        <!-- <th class="blue" style="width: 120px;">{{$t('uom')}}</th> -->
                                        <th class="blue" style="width: 120px;">{{$t('qty')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td style="width: 30px;">
                                            <button type="button"
                                                    class="btn btn-danger btn-remove"
                                                    @click="removeLine(index)">
                                                X
                                            </button>
                                        </td>
                                        <td style="width: 330px"><AuthCompleted productType="1" :value="ret.ItemName" @select="onSelect($event, ret)"></AuthCompleted></td>
                                        <td><input type="text" class="form-control form-control-sm" v-model="ret.Description" /></td>
                                        <!-- <td><UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown></td> -->
                                        <td><input type="text" class="form-control form-control-sm" v-int-only v-model="ret.QuantityIn" min="0" /></td>                                        
                                    </tr>
                                    <tr>
                                        <td colspan="4" class="none-l none-b none-r">
                                            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                        </td>                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('note')}}</label>
                                <div>
                                    <textarea class="form-control form-control-sm" v-model="stockin.Description"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    import UomDropdown from '../UOM/Dropdown';
    import { required } from 'vuelidate/lib/validators';
    import { VendorSelector } from '../Vendors';
    import { Stock } from '../../shared/models/model';
    export default {
        components: {
            AuthCompleted,
            UomDropdown,
            VendorSelector
        },
        data() {
            return {
                title: this.$t('request_stock_in'),
                branchs: [],
                stockin: {
                    BranchId: '',
                    EmployeeId: ''
                },
                lines: [{
                    ItemName: '',
                    Description: '',
                    UomName: '',
                    UomId: 0,
                    Quantity: 1,
                    QuantityIn: 0
                }],
                employees: [],
                invoiceNos: [{
                    Id: '',
                    num: ''
                }],
                stockdate: this.$now().format('YYYY-MM-DD'),
                action: 'stockin/save'
            }
        },
        created() {
            this.getBranch();
            this.getEmployee();
            let id = this.$route.params.id;
            if (id !== undefined && id !== null && id !== '') {
                this.findById(id);
                this.action = 'stockin/update';
            }
        },
        validations: {
            stockin: {
                BranchId: { required },
                EmployeeId: { required }
            }
        },
        methods: {
            getBranch() {
                this.$api().post('branch/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.branchs = res.data.Json.Branches;
                    }
                });
            },
            addLine() {
                this.lines.push({
                    ItemName: '',
                    Description: '',
                    UomName: '',
                    UomId: '',
                    Quantity: 1,
                    QuantityIn: 0
                });
            },
            checkAll() {
                this.lines.map(item => {
                    item.Checked = this.isCheck;
                });
            },
            onSelect(item, line) {
                line.Description = item.data.Name;
                line.ItemId = item.data.Id;
                line.UomId = item.data.UomId;
                line.UomName = item.data.UomName;
            },
            onSave() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    this.stockin.InDateAt = this.stockdate;
                    this.stockin.CompanyId = this.$store.state.company.Id;
                    this.stockin.ClientId = this.$store.state.company.ClientId;
                    let req = {
                        StockIn: this.stockin,
                        StockInLines: this.lines
                    };
                    this.$api().post(this.action, req).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.go(-1);
                        }
                    }).finally(function () { loading.hide(); });
                }
            },
            findById(id) {
                let loading = this.$loading.show();
                Stock.findStockin({ Id: id }).then(res => {
                    this.stockin = res.Json.Header;
                    this.lines = res.Json.Lines;
                    this.title = '[' + this.stockin.Num + ']';
                }).finally(() => { loading.hide(); });
            },
            getEmployee() {
                this.$api().post('employees', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.employees = res.data.Data;
                    }
                });
            },
            uomChange(e, line) {
                line.UomId = e.UomId;
                line.UomName = e.UomName;
            },
            limitNumber(item) {
                if (isNaN(item.QuantityIn) || item.QuantityIn < 0) item.QuantityIn = item.OldQuantity;
                else item.OldQuantity = item.QuantityIn;
            },
            getInvoiceNo(invoiceNo) {
                let self = this;
                self.$api().post('po/invoice/find/number', { Num: invoiceNo }).then(res => {
                    if (this.$isValid(res)) {
                        this.lines = [];
                        res.data.Data.POInvoiceLines.map((key) => {
                            this.lines.push({
                                ItemId: key.ItemId,
                                ItemName: key.ItemName,
                                UomName: key.UomName,
                                UomId: key.UomId,
                                Quantity: key.Quantity,
                                QuantityIn: key.Quantity
                            });
                        });
                    }
                });
            },
            removeLine(index) {
                this.lines.splice(index, 1);
            },
            vendorSelected(e) {
                this.stockin.VendorId = e.data.Id;
            }
        },
        computed: {
            getChecked() {
                return this.lines.filter(function (item) {
                    return item.Checked === true;
                });
            }
        }
    }
</script>